/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Materiality } from './Materiality';
import { MaterialityFromJSON, MaterialityFromJSONTyped, MaterialityToJSON } from './Materiality';
import type { EuAiActRiskClass } from './EuAiActRiskClass';
import { EuAiActRiskClassFromJSON, EuAiActRiskClassFromJSONTyped, EuAiActRiskClassToJSON } from './EuAiActRiskClass';

/**
 *
 * @export
 * @interface UseCaseCount
 */
export interface UseCaseCount {
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof UseCaseCount
   */
  modelsCount: { [key: string]: number };
  /**
   *
   * @type {EuAiActRiskClass}
   * @memberof UseCaseCount
   */
  euAiActRiskCount: EuAiActRiskClass;
  /**
   *
   * @type {Materiality}
   * @memberof UseCaseCount
   */
  materialityCount: Materiality;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof UseCaseCount
   */
  departmentCount: { [key: string]: number };
}

/**
 * Check if a given object implements the UseCaseCount interface.
 */
export function instanceOfUseCaseCount(value: object): value is UseCaseCount {
  if (!('modelsCount' in value) || value['modelsCount'] === undefined) return false;
  if (!('euAiActRiskCount' in value) || value['euAiActRiskCount'] === undefined) return false;
  if (!('materialityCount' in value) || value['materialityCount'] === undefined) return false;
  if (!('departmentCount' in value) || value['departmentCount'] === undefined) return false;
  return true;
}

export function UseCaseCountFromJSON(json: any): UseCaseCount {
  return UseCaseCountFromJSONTyped(json, false);
}

export function UseCaseCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseCount {
  if (json == null) {
    return json;
  }
  return {
    modelsCount: json['models_count'],
    euAiActRiskCount: EuAiActRiskClassFromJSON(json['eu_ai_act_risk_count']),
    materialityCount: MaterialityFromJSON(json['materiality_count']),
    departmentCount: json['department_count'],
  };
}

export function UseCaseCountToJSON(value?: UseCaseCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    models_count: value['modelsCount'],
    eu_ai_act_risk_count: EuAiActRiskClassToJSON(value['euAiActRiskCount']),
    materiality_count: MaterialityToJSON(value['materialityCount']),
    department_count: value['departmentCount'],
  };
}
